import { http, http2 } from "../conf/AxiosConfig.js";
import AppConfig from "@/conf/global.js";

class FiltersOrdinarioDataService {
   getInfo(secondary) {
      let uri = "info";
      if (secondary == null || !secondary) return http.get(uri);
      else return http2.get(uri);
   }

   async getProcesosGenerales(secondary) {
      let uri = AppConfig.ordinarioProcesosGeneralesFiltro;
      if (secondary == null || !secondary) return await http.get(uri);
      else return await http2.get(uri);
   }

   async getComites(secondary, idAmbito) {
      let uri = AppConfig.ordinarioComitesFiltro.concat(idAmbito);
      if (secondary == null || !secondary) return await http.get(uri);
      else return await http2.get(uri);
   }

   async getEntidades(secondary, idAmbito, idOrganizacion) {
      let uri = AppConfig.ordinarioEntidadesFiltro.concat(idAmbito).concat("/").concat(idOrganizacion);
      if (secondary == null || !secondary) return await http.get(uri);
      else return await http2.get(uri);
   }

   async getSujetosObligados(secondary, idAmbito, idOrganizacion, idEstado) {
      let uri = AppConfig.ordinarioSujetosObligadosFiltro.concat(idAmbito).concat("/").concat(idOrganizacion).concat("/").concat(idEstado);
      if (secondary == null || !secondary) return await http.get(uri);
      else return await http2.get(uri);
   }

   setFilters(
      parIdSujetoObligado,
      parIdEstado,
      parIdOrganizacion,
      parIdAmbito,
      parIndexFirstElement,
      parPageMaxSize,
      parOrderField,
      parOrderType,
      parIdContabilidad
   ) {
      let sortType = "ASC";
      if (parOrderType != "ASC" && parOrderType != 1) {
         sortType = "DESC";
      }
      const filters = {
         idSujetoObligado: parIdSujetoObligado,
         idEstado: parIdEstado,
         idOrganizacion: parIdOrganizacion,
         idAmbito: parIdAmbito,
         indexFirstElement: parIndexFirstElement,
         pageMaxSize: parPageMaxSize,
         orderField: parOrderField,
         orderType: sortType,
         idContabilidad: parIdContabilidad,
      };
      return filters;
   }

   /*getContabilidades(filters) {
      return http.get(AppConfig.ordinarioContabilidadesLista, { params: { filters } });
   }
   getContabilidadesConteo(filters) {
      return http.get(AppConfig.ordinarioContabilidadesConteo, { params: { filters } });
   }*/

   getContabilidades(secondary, filters) {
      if (secondary == null || !secondary) return http.post(AppConfig.ordinarioContabilidadesLista, filters);
      else return http2.post(AppConfig.ordinarioContabilidadesLista, filters);
   }
   getContabilidadesConteo(secondary, filters) {
      if (secondary == null || !secondary) return http.post(AppConfig.ordinarioContabilidadesConteo, filters);
      else return http2.post(AppConfig.ordinarioContabilidadesConteo, filters);
   }

   getDetalle(secondary, contabilidad, anio) {
      if (secondary == null || !secondary) return http.post(AppConfig.ordinarioDetalle.concat(anio), contabilidad);
      else return http2.post(AppConfig.ordinarioDetalle.concat(anio), contabilidad);
   }
}

export default new FiltersOrdinarioDataService();
